import { Component, Input } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

@Component({
  selector: 'form-group-select',
  templateUrl: './form-group-select.component.html',
  styleUrls: ['./form-group-select.component.css']
})
export class FormGroupSelectComponent {

  @Input() control: UntypedFormControl;
  @Input() id: string = '';
  @Input() title: string = '';
  @Input() dataSelect: Array<any> = [];
  @Input() messageRequired: string = 'Información es requerida.';
  @Input() tooltip: string | undefined = undefined;
  @Input() enabledDefaultOption: boolean = false;
  @Input() placeholder: string = 'Selecciona una opción';

  constructor() { }


}
